import _some from 'lodash/some'
import _filter from 'lodash/filter'
import _find from 'lodash/find'

export const useGuestTickets = ({ event, tickets, tables, seatMapConnectedIds }) => {
  const isSeatMapEvent = Boolean(event.flagSeatMapAllowed)
  const isTableSeatMap = event.seatMapType === 'table'

  const isDirectTicketsSales = _some(tickets, ticket =>
    isSeatMapEvent ? ticket.allowDirectPurchaseForSeatMap || isTableSeatMap : true,
  )
  const hasRegularTickets = tickets && tickets.length > 0 && isDirectTicketsSales
  const regularTicketsNotConnectedToSeatMap = _filter(tickets, ticket =>
    isSeatMapEvent ? ticket.allowDirectPurchaseForSeatMap || isTableSeatMap : true,
  )
  const regularTicketsConnectedToSeatMap = _filter(
    tickets,
    ticket => !!_find(seatMapConnectedIds, item => String(item) === String(ticket.id)),
  )

  const hasTables = tables && tables.length > 0
  const tablesNotConnectedToSeatMap = _filter(
    tables,
    table => !_find(seatMapConnectedIds, item => String(item) === String(table.id)),
  )
  const tablesConnectedToSeatMap = _filter(
    tables,
    table => !!_find(seatMapConnectedIds, item => String(item) === String(table.id)),
  )

  return {
    hasRegularTickets,
    hasRegularTicketsOnSeatMap: isSeatMapEvent && Boolean(regularTicketsConnectedToSeatMap.length),
    hasRegularTicketsDirectSales: isDirectTicketsSales,
    regularTicketsConnectedToSeatMap,
    regularTicketsNotConnectedToSeatMap,

    hasTables,
    hasTablesOnSeatMap: hasTables && isSeatMapEvent && Boolean(tablesConnectedToSeatMap.length),
    hasTablesDirectSales: hasTables && !isSeatMapEvent,
    tablesConnectedToSeatMap,
    tablesNotConnectedToSeatMap,

    isSeatMapEvent,
    isTableSeatMap,
    isSeatsIo: event.seatProvider === 'seats_io',
  }
}
